import React from 'react'
import { RichText} from 'prismic-reactjs'
import htmlSerializer from '@utils/HtmlSerializer'
import LinkResolver from '@utils/LinkResolver'

const PageDescription = ({description}) => {
    if(description === null || description.length === 0) return null
    return (
        <>
       <RichText render={description} linkResolver={LinkResolver} htmlSerializer={htmlSerializer}/> 
       </>
    )
}

export default PageDescription;